<template>
    <div class="form-group mod">
        <div class="d-flex justify-content-between">
            <label :for="id" class="form-label" :class="{ require: required }">
                {{ title }}
            </label>
            <div class="d-flex align-items-center" v-if="actionText" @click="$emit('action')">
                <div v-if="icon" v-html="htmlIcon"></div>
                <div class="f-14 f-c-blue font-weight-600 m-l-4">{{ actionText }}</div>
            </div>
        </div>
        <div class="position-relative">
            <input type="text" class="form-control"
                    :id="id"
                    :class="{'text-uppercase':uppercase, 'pr-5': clearable}"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    :autocomplete="autocomplete"
                    :readonly="readonly"
                    v-model="componentValue"
                    @input="$emit('input', componentValue)"
                    @focus="$emit('focus')"
            />
            <div v-if="clearable && componentValue" id="clear__input" class="position-absolute" @click="clear()">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L8.41421 7L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3166 14.0976 12.6834 14.0976 12.2929 13.7071L7 8.41421L1.70711 13.7071C1.31658 14.0976 0.683417 14.0976 0.292893 13.7071C-0.0976311 13.3166 -0.0976311 12.6834 0.292893 12.2929L5.58579 7L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z" fill="#6F7287"/>
                </svg>
            </div>
            </div>
    </div>
</template>

<script>
import { regex } from "@/store/utils/vars";

export default {
    name: "SOInputRegular",
    props: {
        title: String,
        id: String,
        placeholder: String,
        value: {
            type: String,
            default: "",
        },
        validation: String,
        required: Boolean,
        uppercase: Boolean,
        disabled: Boolean,

        actionText: String,
        icon: Boolean,
        htmlIcon: {
            type: String,
            default: `<svg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <path d='M9 4H5C4.44772 4 4 4.44772 4 5V9C4 9.55228 4.44772 10 5 10H9C9.55228 10 10 9.55228 10 9V5C10 4.44772 9.55228 4 9 4Z' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M7 17V17.01' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M19 4H15C14.4477 4 14 4.44772 14 5V9C14 9.55228 14.4477 10 15 10H19C19.5523 10 20 9.55228 20 9V5C20 4.44772 19.5523 4 19 4Z' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M7 7V7.01' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M9 14H5C4.44772 14 4 14.4477 4 15V19C4 19.5523 4.44772 20 5 20H9C9.55228 20 10 19.5523 10 19V15C10 14.4477 9.55228 14 9 14Z' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M17 7V7.01' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M14 14H17' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M20 14V14.01' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M14 14V17' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M14 20H17' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M17 17H20' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                        <path d='M20 17V20' stroke='#206CFF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/>
                      </svg>`,
        },
        autocomplete: {
            type: String,
            default: "on", // on || off
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        clearable: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            componentValue: "",
            regexType: {
                default: regex.default,
                alphanumeric: regex.alphanumeric,
                email: regex.email,
                emoji: regex.emoji,
            },
        };
    },
    watch: {
        value: {
            handler: function() {
                this.doRegex();
            },
        },
    },
    mounted() {
        this.doRegex();
    },
    methods: {
        doRegex() {
            if (this.validation === "") {
                this.validation = "alphanumeric";
            }
            let regexType = this.regexType[this.validation];
            this.componentValue = this.value.replace(regexType, "");
            this.componentValue = this.componentValue.replace(this.regexType.emoji, "");
            if (this.uppercase) {
                this.componentValue = this.componentValue.toUpperCase();
            }

            this.$emit("input", this.componentValue);
        },
        clear() {
            this.componentValue = ""
            this.$emit('input', this.componentValue)
            this.$emit('clear')
        }
    },
};
</script>
<style scoped>
#clear__input {
  top: 10px;
  right: 24px;
}
</style>